import {DisclaimersModel} from "../models/view/disclaimersModel";
import {useProductDetailsQuery} from "./useProductDetailsQuery";

export const useDisclaimersQuery = () => {
    const {model: {disclaimers}} = useProductDetailsQuery();
    return {model: new DisclaimersModel(disclaimers)};
}